import { z } from 'zod';
export const SORT_OPTIONS = ['added_desc', 'rating_desc', 'title_asc'];
export const sortSchema = z.enum(SORT_OPTIONS);
export const SORT_LABELS = {
    added_desc: 'По дате добавления',
    rating_desc: 'По оценке',
    title_asc: 'По названию',
};
//# sourceMappingURL=sort.js.map